// px
export const fontSizes: { [size: string]: number } = {
    small: 12,
    normal: 14,
    large: 16,
    xlarge: 20,
    xxlarge: 28,
    mapicon: 32,
};
